import { useGetDaasEntities } from '../useGetDaasEntities';

export const useGetDaasApplications = (
  userOwedApplications: boolean = false,
  userInSecurityGroup: boolean = false,
) => {
  return useGetDaasEntities(
    'daas-application',
    userOwedApplications,
    userInSecurityGroup,
  );
};
